import { IProductPageResponse } from "@faire/web-api/indigofair/data/IProductPageResponse";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";
import { DefaultTheme } from "@faire/web/slate/Theme";

// Firefox increases the height of each list item by 1 to 1.5px
export const SCROLL_HEIGHT_MARGIN_OF_ERROR = 1.1;
export const TRANSITION_DURATION = 250;
export const ACCORDION_TRANSITION_TIMING = `
  transition-duration: ${TRANSITION_DURATION}ms;
  transition-timing-function: ease-out;
`;
const DEFAULT_LINE_HEIGHT = "20px";

const getCSSLineHeight = (): string => {
  const lineHeightAttribute =
    DefaultTheme.typography.fonts.paragraphSansRegular["line-height"];

  return lineHeightAttribute?.toString() ?? DEFAULT_LINE_HEIGHT;
};

export const getLineHeight = (): number => {
  const lineHeightFromCSSLineHeight = parseInt(getCSSLineHeight());

  return isNaN(lineHeightFromCSSLineHeight)
    ? parseInt(DEFAULT_LINE_HEIGHT)
    : lineHeightFromCSSLineHeight;
};

export const getProductDetailsEntriesTexts = (
  entries?: IProductPageResponse.IPdpProduct.IDetails.IProductInformationSubSection.IProductInformationSubSectionEntry[]
) => {
  return (
    entries
      ?.map((entry) => entry.text?.translated ?? entry.text?.original)
      .filter(isNotUndefined) ?? []
  );
};

export const getProductDetailsEntriesAttributes = (
  entries?: IProductPageResponse.IPdpProduct.IDetails.IProductInformationSubSection.IProductInformationSubSectionEntry[]
) => {
  return (
    entries
      ?.map((entry) => ({
        name:
          entry.attribute?.name?.translated ?? entry.attribute?.name?.original,
        value:
          entry.attribute?.value?.translated ??
          entry.attribute?.value?.original,
        text: entry.text?.translated ?? entry.text?.original,
      }))
      .filter(
        (attribute) =>
          isNotUndefined(attribute.name) ||
          isNotUndefined(attribute.value) ||
          isNotUndefined(attribute.text)
      ) ?? []
  );
};
